import React from "react";
import { useFormikContext } from "formik";
import { fieldTypes, SPECIALTY_CD } from "../constants";
import { SharePanelFieldContainer } from "../components";
import { loadProviders } from "../apis/loadProviders";
import { debounce, map, reject } from "lodash";
import { translate } from "@td/shared_utils";
import { FieldLabel, SelectInput, List } from "@td/ui";
import { useProviderPanel } from "../contexts/provider-panel-context";

const LOAD_OPTIONS_LIMIT = 8;
const LOAD_OPTIONS_DEBOUNCE_DELAY = 500;

const SharePanelField = React.memo(() => {
  const { values, setFieldValue } = useFormikContext();
  const { provider } = useProviderPanel();
  const sharePanel = values[fieldTypes.SHARE_PANEL];

  const handleDelete = ({ value }) => {
    setFieldValue(fieldTypes.SHARE_PANEL, reject(sharePanel, ["value", value]));
  };

  const loadOptions = async (inputValue, callback) => {
    const value = inputValue.replace(/\s+/g, " ").trim();

    if (!value) {
      callback(null);

      return;
    }

    const providers = await loadProviders({
      id: value,
      nameSearchString: value,
      specialtyCd: SPECIALTY_CD.VPC,
      except: map(sharePanel, ({ value }) => value.toString()).concat(provider.id),
    }, LOAD_OPTIONS_LIMIT);

    callback(providers.map(({ id, nameWithCredentials }) => ({ value: parseInt(id), label: nameWithCredentials })));
  };

  const debouncedLoadOptions = debounce((inputValue, callback) => {
    loadOptions(inputValue, callback);
  }, LOAD_OPTIONS_DEBOUNCE_DELAY);

  const handleChange = (option) => {
    setFieldValue(fieldTypes.SHARE_PANEL, [...sharePanel, option]);
  };

  return (
    <SharePanelFieldContainer>
      <FieldLabel>
        {translate(null, "provider_panel.form.fields.share_panel", "label")}:

        <SelectInput
          async
          value={null}
          loadOptions={debouncedLoadOptions}
          onChange={handleChange}
          placeholder={translate(null, "provider_panel.form.fields.share_panel", "placeholder")}
          components={{
            DropdownIndicator: null,
          }}
        />
      </FieldLabel>
      <List
        deletable
        data={sharePanel}
        selector={({ label }) => label}
        onDelete={handleDelete}
      />
    </SharePanelFieldContainer>
  );
});

export default SharePanelField;
